/**
 * Computes the PAIN Virtual Account for a given KRO (Kirchenrechnungsordnung) identifier.
 * The logic follows the Django backend implementation:
 * f"DE{checksum}91100062{kro}" where checksum = f"{98 - (int(f'91100062{kro}131400') % 97):02d}"
 *
 * @param {string} kro - The 10-digit KRO identifier.
 * @returns {string|null} The computed IBAN (DE...) or null if KRO is invalid.
 */
export function calculateVirtualAccount (kro) {
  if (!kro || typeof kro !== 'string' || kro.length !== 10 || !/^\d+$/.test(kro)) {
    return null
  }

  const base = `91100062${kro}131400`
  // Use BigInt for the large number modulo operation
  const checksum = 98n - (BigInt(base) % 97n)
  const checksumStr = checksum.toString().padStart(2, '0')

  return `DE${checksumStr}91100062${kro}`
}
